import * as Adaptive from 'adaptivecards';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { isFeatureEnabled } from 'owa-feature-flags';

export default class CustomImage extends Adaptive.Image {
    private smtp: string;
    private lpcElement: HTMLDivElement;

    protected internalRender(): HTMLElement {
        if (!this.smtp || !isFeatureEnabled('rp-actionableMessages-lpc')) {
            return super.internalRender();
        }
        /* tslint:disable:no-string-literal */
        const LivePersonaCardHoverTargetV2 = window['LivePersonaCardHoverTargetV2'];
        /* tslint:enable:no-string-literal */
        this.lpcElement = document.createElement('div');
        let innerContent: HTMLDivElement;

        const lpcCard = (
            <LivePersonaCardHoverTargetV2
                cardParameters={{
                    personaInfo: {
                        identifiers: {
                            Smtp: this.smtp,
                            PersonaType: 'User',
                        },
                    },
                    behavior: {
                        locationToOpen: 'Card',
                    },
                }}>
                <div ref={div => (innerContent = div)} />
            </LivePersonaCardHoverTargetV2>
        );
        ReactDOM.render(lpcCard, this.lpcElement);
        innerContent.appendChild(super.internalRender());
        return this.lpcElement;
    }

    remove(): boolean {
        if (this.lpcElement) {
            ReactDOM.unmountComponentAtNode(this.lpcElement);
            this.lpcElement = null;
        }

        return super.remove();
    }

    public parse(json: any) {
        super.parse(json);
        this.smtp = json.smtp;
    }
}
